<!--
 * @Author: Lihao sun sunlihao.cosmo@haier.com
 * @Date: 2024-12-19 09:59:56
 * @LastEditors: Lihao sun sunlihao.cosmo@haier.com
 * @LastEditTime: 2024-12-19 14:41:34
 * @FilePath: src/App.vue
 * @Description: 这是默认设置,可以在设置》工具》File Description中进行配置
-->
<template>
  <div id="base-app" v-watermark="watermarkOptions" class="base supper-app-base">
    <router-view></router-view>
  </div>
</template>

<script>
import { getConfigByCode } from '@/api/setting'

export default {
  name: 'App',
  data() {
    return {
      faviconUrl: '', // 新增faviconUrl
      tabTitle: '', // 新增tabTitle
      watermarkOptions: {
        text: ['', ''], // 水印文字
        color: 'rgba(200, 200, 200, 0.4)', // 水印颜色
        fontSize: '20px', // 文字大小
        rotate: -45, // 旋转角度
        density: [100, 100],
        padding: [200, 80]
      },
      // animationFrameId: null
      updateTimer: null
    }
  },
  mounted() {
    // 路由初始化完成后隐藏 loading
    const hideLoading = () => {
      const loading = document.getElementById('app-loading')
      if (loading) {
        loading.style.transition = 'opacity 0.3s'
        loading.style.opacity = '0'
        setTimeout(() => {
          loading.style.display = 'none'
        }, 300)
      }
    }
    // 15秒兜底：无论路由是否 ready，强制隐藏 loading
    setTimeout(hideLoading, 15000)
    // 路由首次导航完成后隐藏
    this.$router.onReady(() => {
      hideLoading()
    })

    this.faviconUrl = this.$store.state.config.clientEndIco
    this.tabTitle = this.$store.state.config.clientEndTitle
    this.$nextTick(() => {
      this.setTabData()
    })

    // // 使用 requestAnimationFrame 实现时间更新
    // const updateTime = () => {
    //   if (this.$store.state.user && this.$store.state.user.userInfo) {
    //     const userName = this.$store.state.user.userInfo.userName || ''
    //     // 获取当前时间并格式化为 YYYY:MM:DD HH:mm:ss 格式
    //     const now = new Date()
    //     const timeStr = `${now.getFullYear()}:${String(now.getMonth() + 1).padStart(2, '0')}:${String(now.getDate()).padStart(2, '0')} ${String(now.getHours()).padStart(2, '0')}:${String(now.getMinutes()).padStart(2, '0')}:${String(now.getSeconds()).padStart(2, '0')}`

    //     this.watermarkOptions = {
    //       ...this.watermarkOptions,
    //       text: [userName, timeStr]
    //     }
    //   }
    //   this.animationFrameId = requestAnimationFrame(updateTime)
    // }
    getConfigByCode({
      code: 'enable_watermark'
    }).then(res => {
      if (res.data?.configValue === 'true') {
        // updateTime()
        // this.$nextTick(() => {
        setTimeout(() => {
          this.updateTime()
        }, 1500)
        // })
      }
    })
  },
  beforeDestroy() {
    // // 清理动画帧
    // if (this.animationFrameId) {
    //   cancelAnimationFrame(this.animationFrameId)
    //   this.animationFrameId = null
    // }
    if (this.updateTimer) {
      clearInterval(this.updateTimer)
      this.updateTimer = null
    }
  },
  methods: {
    updateTime() {
      // 立即执行一次
      this.updateWatermarkText()
      // 之后每秒执行一次（替代requestAnimationFrame的高频更新）
      this.updateTimer = setInterval(() => {
        this.updateWatermarkText()
      }, 10000)
    },
    updateWatermarkText() {
      if (this.$store.state.user?.userInfo) {
        const userName = this.$store.state.user.userInfo.userName || ''
        const now = new Date()
        // 格式化时间（YYYY:MM:DD HH:mm:ss）
        const timeStr = `${now.getFullYear()}/${
          String(now.getMonth() + 1).padStart(2, '0')
        }/${String(now.getDate()).padStart(2, '0')} ${
          String(now.getHours()).padStart(2, '0')
        }:${String(now.getMinutes()).padStart(2, '0')}`
        // :${
        //   String(now.getSeconds()).padStart(2, '0')
        // }
        // const timeStr = `${now.getFullYear()}/${
        //   String(now.getMonth() + 1).padStart(2, '0')
        // }/${String(now.getDate()).padStart(2, '0')} ${
        //   String(now.getHours()).padStart(2, '0')
        // }:${String(now.getMinutes()).padStart(2, '0')}:${
        //   String(now.getSeconds()).padStart(2, '0')
        // }`

        // 更新水印配置（会触发componentUpdated钩子）
        // this.watermarkOptions.text = [userName, timeStr]
        this.watermarkOptions = {
          ...this.watermarkOptions,
          text: [userName, timeStr]
        }
      }
    },
    setTabData() {
      document.title = this.tabTitle // 设置浏览器tab标题
      this.setFavicon()
    },
    setFavicon() {
      let link = document.querySelector("link[rel~='icon']")
      if (!link) {
        link = document.createElement('link')
        link.rel = 'icon'
        document.getElementsByTagName('head')[0].appendChild(link)
      }
      link.href = this.faviconUrl
    }
  }
}
</script>

<style>
body {
  width: 100%;
  margin: 0 !important;
  font-size: 16px;
}
#base-app {
  position: relative;
  height: 100%;
  font-size: 16px!important;
}
</style>
